import {getLogger} from "@prosay/logging"
import React, {useCallback, useEffect, useState} from "react"
import {StyleSheet, View} from "react-native"
import {Button} from "react-native-paper"

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        height: 40,
        justifyContent: "space-around",
        marginTop: 10,
    },
    tabButton: {},
})

const logger = getLogger(__filename)

export interface TabBarButtonProps<Tab extends string> {
    active: Tab | undefined
    setActive: (tab: Tab) => void
    tab: Tab
}
export const TabBarButton = <Tab extends string>({
    active,
    setActive,
    tab,
}: TabBarButtonProps<Tab>) => {
    const onPress = useCallback(() => setActive(tab), [setActive, tab])

    return (
        <Button
            key={tab}
            style={styles.tabButton}
            mode={active === tab ? "contained" : "text"}
            onPress={onPress}>
            {tab}
        </Button>
    )
}

export interface TabBarNavigationProps<Tab extends string> {
    initialTab?: Tab
    onChangeTab: (tab: Tab) => void
    tabs: readonly Tab[]
}
export const TabBar = <Tab extends string>({
    initialTab,
    onChangeTab,
    tabs,
}: TabBarNavigationProps<Tab>) => {
    const [active, setActive] = useState<Tab | undefined>(initialTab)
    useEffect(() => {
        if (!active) {
            return
        }

        logger.info`Active tab set to ${active}`
        onChangeTab(active)
    }, [active, onChangeTab])

    return (
        <View style={styles.container}>
            {tabs.map(tab => (
                <TabBarButton
                    key={tab}
                    active={active}
                    setActive={setActive}
                    tab={tab}
                />
            ))}
        </View>
    )
}
